import { getExperiment } from '@eventbrite/statsig';
import React, { useEffect, useState } from 'react';
import { useHasUrgencySignalsEnabled } from './provider';

export const UrgencySignalsExperimentWrapper: React.FC = ({ children }) => {
    const [isExperimentEnabled, setIsExperimentEnabled] = useState(false);
    const hasUrgencySignalsEnabled = useHasUrgencySignalsEnabled();

    useEffect(() => {
        if (!hasUrgencySignalsEnabled) {
            setIsExperimentEnabled(false);
            return;
        }

        const value = getExperiment<boolean, boolean>(
            'urgency_signals_in_new_listing_page',
            'is_experiment_enabled',
            false,
        );

        setIsExperimentEnabled(value);
    }, [hasUrgencySignalsEnabled]);

    return isExperimentEnabled ? <>{children}</> : <></>;
};
